import { ImportItemResultContract } from "../contracts/ImportItemResultContract";
import { ImportResultResponse } from "../contracts/ImportResultResponse";
import { ImportResult } from "../models/ImportResult";
import { ImportResultItem } from "../models/ImportResultItem";

/** Maps API import result responses to frontend ImportResult models */
export class ImportResultResponseMapper {
  toImportResult = (response: ImportResultResponse): ImportResult => {
    return {
      members: (response.members ?? []).map(this.toItem),
      groups: (response.groups ?? []).map(this.toItem),
      sessions: (response.sessions ?? []).map(this.toItem),
    };
  };

  private toItem = (item: ImportItemResultContract): ImportResultItem => {
    return {
      tempId: item.tempId,
      label: item.label,
      createdId: item.createdId,
      error: item.error,
    };
  };
}
